export const ConsumerAuthenticationLoadingViewStyles = {
  container: 'm-10',
  paragraph: 'mt-8',
}
